import { sendVerifyCodeApi, registerApi, registerPhoneIsExistApi, registerRandomCodeApi, logApi} from '@/api/login.js';
import { getExpiresTime } from '@/util/public.js'
import { Base64 } from "js-base64";
import { mapMutations } from "vuex";
export default {
  data(){
    return {
      formRule: {
        account: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
                  { validator: this.validateForm, trigger: "blur" }],
        password: [{ required: true, message: '请输入密码', trigger: ['blur', 'change'] },
                   { validator: this.validateForm, trigger: ['blur', 'change'] }],
        verifyCode: [{ validator: this.validateForm, trigger: ['blur', 'change'] }],
        messageCode: [{ required: true, message: '请输入验证码', trigger: ['blur', 'change'] }],
        agree: [
          { type: 'boolean', required: true, message: '请阅读并同意政策或规则', trigger: 'change' },
          { validator: this.validateForm, trigger: ['blur', 'change'] }
        ],
      },
      errTip: '',
      btnLoading: false
    }
  },
  methods: {
    ...mapMutations(['setState', 'setSocketConnectOnOutline']),
    //注册登录校验
    validateForm(rule, value, callback){
      if (rule.field == 'account' && this.activeType == 1) {
        if (!value) {
          return callback(new Error('请输入手机号'));
        }
        if (value.length > 64) {
          return callback(new Error('长度过长（不超过64个字符）'));
        }
        if (!/[$\w_\d]+$/i.test(value)) {
          return callback(new Error('用户名不正确'));
        }
      }
      if (rule.field == 'account' && this.activeType == 2) {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        }
        if (!/^1[3-9][0-9]{9}$/.test(value)) {
          return callback(new Error('无效的手机号'));
        }
        this.phoneIsExist()
      }
      if (rule.field == 'password' && this.activeType == 2) {
        if (!value) {
          return callback(new Error('请输入密码'));
        }
        if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)) {
          return callback(new Error('密码为6-20位数字字母组合，区分大小写'));
        }
      }
      if (rule.field == 'verifyCode' && this.showVerifyCode) {
        if (!value || this.code.toLowerCase() !== value.toLowerCase()) {
          return callback(new Error('请输入正确的验证码'));
        }
      }
      // if (rule.field == 'agree' && !value) {
      //   return callback(new Error('请阅读并接受使用协议和隐私政策'));
      // }
      callback();
    },
    //手动登录
    login() {
       this.$refs.logForm.validate(async valid => {
          if (!valid) return;
          this.btnLoading=true;
          this.loginNormal();
       });
    },
    //手动登录：接口
    async loginNormal(){
      const data=await logApi({
        userName:this.logForm.account,
        password:Base64.encode(this.logForm.password),
        randomCode:this.logForm.verificationCode,
        platform: 2
      })
      this.btnLoading=false
      if(!data.success){
          this.$message.error({message:data.message,offset:100,duration:1500});
          if(data.message.includes('密码错误')||data.message.includes('登录失败次数过多')){
            this.showVerifyCode=true;
            this.getImgVerifyCode();
          }
          return;
      }
      this.closeLog()
      if(data.content.isEnable == false){
        this.$parent.$parent.isBlackUser = true
      }
      await this.toSaveCookie(data.content)
      this.setState({key:"userInfo",value:data.content})
      this.setState({key:'isLogged',value:true})
      this.$parent.$parent.setOrg()
      this.setSocketConnectOnOutline(true)
      if(this.$parent.returnUrl) window.open(this.$parent.returnUrl, "_blank")
    },
    //手动登录：成功去存储cookie
    toSaveCookie(info){
      let uid=info.accessToken
      if(!uid)return;
      //存储电商平台所需cookie
      //mm/dd/yy+hh:mm:ss
      let linId=`LinID=${uid}&ot=${encodeURIComponent(new Date().format("MM/dd/yyyy hh:mm:ss"))}`;
      let ecpValue={
      'IsAutoLogin':true,'UserName':info.userName,'ShowName':info.realName,'UserType':'jf'
      ,'BUserName':'','BShowName':'','BUserType':'','r':'uqpGOF'
      };
      let expiresTime = getExpiresTime(30)
      document.cookie=`Ecp_LoginStuts=${JSON.stringify(ecpValue)};expires=${new Date().getTime()+24*3600*1000};path=/;`;
      document.cookie=`c_m_LinID=${linId};expires=${expiresTime};path=/`;
      document.cookie=`LID=${uid};expires=${new Date().getTime()+24*3600*1000};domain=.agriknow.cn;path=/;`;
      document.cookie=`LID=${uid};expires=${new Date().getTime()+24*3600*1000};domain=ai.agriknow.cn;path=/;`;
      document.cookie=`c_m_expire=${encodeURIComponent(new Date().format("yyyy-MM-dd hh:mm:ss"))};expires=${expiresTime};path=/;`;
    },
    //手动登录：密码错误时获取随机验证码
    async getImgVerifyCode(){
      let res = await registerRandomCodeApi();
      if (!res.content || !res.success) {
        this.errTip = res.message;
      } else {
        this.code = res.content;
      }
    },
    //注册：手机号是否已注册
    async phoneIsExist(){
      if(this.activeType != 2) return
      let data = await registerPhoneIsExistApi({
        phone:this.logForm.account
      })
      if(!data.success) return this.errTip = data.message
      else return this.errTip = ''
    },
    //注册：获取短信验证码
    getMessageCode(){
      let timer = 90,
      intervalTimer;
      if (this.sending) return;
      this.sending = true;
      intervalTimer = setInterval(() => {
        this.verifyText = timer + " 秒后重新发送";
        timer--;
        if (timer == 0) {
          clearInterval(intervalTimer);
          this.verifyText = "重新发送验证码";
          this.sending = false;
        }
      }, 1000);
      sendVerifyCodeApi({ phone: this.logForm.account }).then((res) => {
        if (res.success) {
          this.$message.success({message:'验证码已发送，请查收！',duration:1500});
          this.errTip = '';
        }else {
          clearInterval(intervalTimer);
          this.verifyText = "点击发送验证码";
          this.sending = false;
          this.$message.error({message:res.message,duration:1500});
          return
        }
      })
    },
    //注册
    register(){
      this.$refs['logForm'].validate(async (valid) =>
      {
        if (!valid) return;
        this.btnLoading = true;
        let res = await registerApi({
          phone: this.logForm.account,
          password: Base64.encode(this.logForm.password),
          verifyCode: this.logForm.messageCode,
        })
        this.btnLoading = false;
        if (!res.content || !res.success) {
          this.errTip = res.message;
        } else {
          this.errTip = '';
          this.$message.success({message:'注册成功，请前往登录！',duration:1500})
          this.logForm.messageCode = '';
          this.activeType = 1;
        }
      });
    },
  }
}